import SearchResultCard from './container';

export default SearchResultCard;
